import React, { Component } from 'react';
import KeyboardEventHandler from 'react-keyboard-event-handler';

import { setCaption } from './PhotosRest';

import checkIcon from './check.svg';
import closeIcon from './close2.svg';

export default class MediaCaption extends Component {
    constructor(props) {
	super(props);
	this.state = {
	    caption: props.media.caption
	};
    }

    updateCaption = e => this.setState({ caption: e.target.value });

    saveCaption = () => {
	setCaption(this.props.media.id, this.state.caption,
		   () => this.props.media.caption = this.state.caption);
	this.props.media.caption = this.state.caption;
	this.setState({ caption: '' });
	this.props.update();
	this.props.toggle();
    }

    handleKeys = (key, event) => {
	if (key === 'enter') {
	    this.saveCaption();	    
	    return;
	}
	if (key === 'esc') {
	    this.props.toggle();
	    return;
	}
    }

    render() {
 	if (this.props.edit) {
	    return (<div className='caption'>
		    <input type='text' defaultValue={this.props.media.caption} onChange={this.updateCaption} autoFocus/>
		    <img src={closeIcon} alt='close' className='close' onClick={this.props.toggle} />
		    <img src={checkIcon} alt='check' className='check' onClick={this.saveCaption} />
		    <KeyboardEventHandler
		    handleKeys={['esc', 'enter']}
		    onKeyEvent={this.handleKeys}
		    handleFocusableElements={true}
		    isExclusive={true}/>
		    </div>);
	} else {
	    return (<div className='caption'>{this.props.media.caption}</div>);
	}
    }
}
